import APIClient from "../../APIClient";

import { SEARCH_DATA_LOADED } from "./types";

const searchDataLoaded = payload => ({
  payload,
  type: SEARCH_DATA_LOADED,
});

export const loadSearchData = () => dispatch => {
  APIClient.get(`/uw/pre_approvals`).then(
    (resp: any) => {
      dispatch(searchDataLoaded(resp.pre_approvals));
    },
    () => {
      dispatch(searchDataLoaded([]));
    },
  );
};

export default loadSearchData;
